/**
 * Specify the position of the text/ticks.
 * Left/Right are the valid options for a vertical colorbars and Top/Bottom
 * for the horizontal ones.
 */
export enum ColorbarRangeTextPosition {
  Top = 'top',
  Left = 'left',
  Bottom = 'bottom',
  Right = 'right',
}
